import { render } from "./EventList.vue?vue&type=template&id=b686d2bc&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=b686d2bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b686d2bc"

export default script